
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import {
    UiStatusIcon,
} from '@hubsolv/hubsolv-ui'

@Component({
    components: {
        UiStatusIcon,
    },
})
export default class UiToggle extends Vue {
    
    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////

    @Prop({ type: Boolean, required: true }) value!: boolean
    @Prop({ type: Boolean, default: false }) indeterminate!: boolean
    @Prop({ type: String, default: null }) label!: string | null
    @Prop({ type: String, default: null }) info!: string | null
    @Prop({ type: Boolean, default: false }) light!: boolean
    @Prop({ type: Boolean, default: false }) disabled!: boolean

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get classes () {
        return {
            'light': this.light,
            'disabled': this.disabled,
        }
    }

    ////////////////////////////////////////////////////////////////
    // lifecycle
    ////////////////////////////////////////////////////////////////

    mounted () {
        this.setIndeterminate(this.indeterminate)
    }

    ////////////////////////////////////////////////////////////////
    // watchers
    ////////////////////////////////////////////////////////////////

    @Watch('indeterminate')
    onChangeIndeterminate (indeterminate: boolean) {
        this.setIndeterminate(indeterminate)
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    setIndeterminate (indeterminate: boolean) {
        const checkbox = this.$refs.checkbox as HTMLInputElement
        checkbox.indeterminate = indeterminate
    }

    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

    onClick (event: MouseEvent) {
        this.$emit('input', (event.target as HTMLInputElement).checked)
    }
    
}
